import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['canvas', 'chemdoodleWrapper', 'smilesWrapper', 'activeInput']
  static values = {
    molblock: String
  }

  connect() {
    this.setupChemdoodle()
  }

  setupChemdoodle() {
    this.cd = new ChemDoodle.SketcherCanvas(
      'chemdoodle',
      600,
      300,
      { oneMolecule: true, useServices: false }
    );
    this.cd.toolbarManager.buttonSave.getElement().style.display = 'none'; // remove save button from toolbar
    this.cd.toolbarManager.buttonOpen.getElement().style.display = 'none'; // remove open file button from toolbar
    this.cd.toolbarManager.buttonTemplate.getElement().style.display = 'none'; // remove molecule template button from toolbar

    if (this.molblockValue !== '') {
      let molecule = ChemDoodle.readMOL(this.molblockValue)
      this.cd.loadMolecule(molecule)
    }
  }

  // this is designed for htmx:configRequest event
  addMolfileToRequest(event) {
    let molfile = ChemDoodle.writeMOL(this.cd.getMolecule())
    event.detail.parameters.append('molfile', molfile)
  }

  toggleInput(event) {
    if (/smiles/i.test(event.target.textContent)) {
      this.showSmiles(event)
    } else {
      this.showChemdoodle(event)
    }
  }

  showChemdoodle(event) {
    let btn = event.target
    let currentText = btn.textContent
    btn.textContent = btn.dataset.otherText
    btn.dataset.otherText = currentText
    this.chemdoodleWrapperTarget.classList.remove('d-none')
    this.smilesWrapperTarget.classList.add('d-none')
    this.activeInputTarget.value = 'chemdoodle'
  }

  showSmiles(event) {
    let btn = event.target
    let currentText = btn.textContent
    btn.textContent = btn.dataset.otherText
    btn.dataset.otherText = currentText
    this.chemdoodleWrapperTarget.classList.add('d-none')
    this.smilesWrapperTarget.classList.remove('d-none')
    this.activeInputTarget.value = 'smiles'
  }
}
